import React, { useState } from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import { FaBan } from "react-icons/fa";
import "@fontsource/chivo";

// Icons & Flags
import regolamentoIcon from "../regolamento.png";
import orologioIcon from "../orologio.png";
import ombrelloIcon from "../ombrello.png";
import sediaIcon from "../sedia.png";
import pallaIcon from "../palla.png";
import casseIcon from "../casse.png";
import famigliaIcon from "../famiglia.png";
import animaliIcon from "../animali.png";
import frigoIcon from "../frigo.png";

// Flags
import flagIT from "../italy.png";
import flagEN from "../united-kingdom.png";
import flagFR from "../france.png";
import flagDE from "../germany.png";
import backgroundImage from "../back.jpg"; // adjust the path if needed


const Regolamento = () => {
  const [language, setLanguage] = useState("it");

  const rules = {
    it: {
      title: "Regolamento",
      entries: [
        { icon: orologioIcon, text: "L'orario di balneazione è compreso tra le 8:00 e le 18:30" },
        { icon: ombrelloIcon, text: "Ogni postazione ombrellone è utilizzabile da un massimo di 2 adulti" },
        { icon: sediaIcon, text: "L'utilizzo degli arredi da spiaggia è strettamente personale e non può essere ceduto a terzi" },
        { icon: pallaIcon, text: "Il gioco del pallone è vietato, nel rispetto delle normative della Capitaneria di Porto e a tutela della tranquillità dell'intera clientela" },
        { icon: casseIcon, text: "È vietato l'utilizzo di apparecchi di diffusione sonora come stereo o casse Bluetooth" },
        { icon: famigliaIcon, text: "S'invita la clientela a rispettare gli spazi riservati al proprio ombrellone e ad adottare comportamenti atti a non recare disturbo al prossimo. La spiaggia è un luogo di relax e tranquillità." },
      ],
      prohibited: "È VIETATO L'INGRESSO DI",
      extra: "Lo staff si riserva il diritto di allontanare tutti gli utenti che, per qualsiasi ragione, violino tali norme.\nRegolamento completo all'interno della struttura.",
      animals: "Animali da compagnia",
      // coolers: "Contenitori termici",
    },
    en: {
      title: "Rules",
      entries: [
        { icon: orologioIcon, text: "Swimming is allowed from 8:00 AM to 6:30 PM" },
        { icon: ombrelloIcon, text: "Each umbrella spot is for a maximum of 2 adults" },
        { icon: sediaIcon, text: "Beach furniture is strictly personal and cannot be lent to others" },
        { icon: pallaIcon, text: "Ball games are not allowed, in compliance with port authority rules and to protect guest peace" },
        { icon: casseIcon, text: "No loudspeakers, Bluetooth speakers or similar devices allowed" },
        { icon: famigliaIcon, text: "Please respect your reserved area and behave respectfully. The beach is a place of peace and relaxation." },
      ],
      prohibited: "PROHIBITED ENTRY",
      extra: "Staff reserves the right to remove anyone who violates these rules for any reason.\nFull rules available on-site.",
      animals: "Pets",
      // coolers: "Thermal containers",
    },
      fr: {
      title: "Règlement",
      entries: [
        { icon: orologioIcon, text: "Les heures de baignade sont de 8h00 à 18h30" },
        { icon: ombrelloIcon, text: "Chaque emplacement avec parasol est limité à 2 adultes maximum" },
        { icon: sediaIcon, text: "Les équipements de plage sont strictement personnels et ne peuvent être prêtés à des tiers" },
        { icon: pallaIcon, text: "Les jeux de ballon sont interdits, conformément aux règles de la capitainerie et pour garantir la tranquillité des clients" },
        { icon: casseIcon, text: "Les appareils sonores tels que les enceintes Bluetooth sont interdits" },
        { icon: famigliaIcon, text: "Merci de respecter votre espace réservé et d’adopter un comportement respectueux. La plage est un lieu de détente et de tranquillité." },
      ],
      prohibited: "ENTRÉE INTERDITE À",
      extra: "Le personnel se réserve le droit d’éloigner toute personne ne respectant pas ce règlement.\nRèglement complet affiché sur place.",
      animals: "Animaux de compagnie",
      // coolers: "Glacières / Conteneurs thermiques",
    },
    de: {
      title: "Hausordnung",
      entries: [
        { icon: orologioIcon, text: "Badezeit ist zwischen 8:00 und 18:30 Uhr erlaubt" },
        { icon: ombrelloIcon, text: "Jeder Sonnenschirmplatz ist für maximal 2 Erwachsene vorgesehen" },
        { icon: sediaIcon, text: "Strandmöbel sind streng persönlich und dürfen nicht weitergegeben werden" },
        { icon: pallaIcon, text: "Ballspiele sind verboten, gemäß den Vorschriften des Hafenamtes und zum Schutz der Ruhe aller Gäste" },
        { icon: casseIcon, text: "Verbot von Lautsprechern und Bluetooth-Boxen" },
        { icon: famigliaIcon, text: "Bitte respektieren Sie Ihren reservierten Bereich und verhalten Sie sich rücksichtsvoll. Der Strand ist ein Ort der Ruhe." },
      ],
      prohibited: "DER ZUTRITT IST VERBOTEN FÜR",
      extra: "Das Personal behält sich das Recht vor, Personen, die gegen die Regeln verstoßen, vom Gelände zu verweisen.\nDie vollständige Hausordnung ist vor Ort einsehbar.",
      animals: "Haustiere",
      // coolers: "Kühlboxen / Thermobehälter",
    },
  };

  const activeRules = rules[language];

  return (
    <div
    className="min-h-screen font-[chivo] bg-cover bg-center bg-no-repeat text-black"
    style={{ backgroundImage: `url(${backgroundImage})` }} // 👈 back.jpg
  >
    {/* Optional white overlay for readability */}
    <div className="bg-white/80 min-h-screen">
      <NavbarWhite />

      <div className="pt-32 px-6 text-center">
        {/* Title + Language Toggle */}
        <div className="flex flex-col items-center justify-center mb-6">
  {/* 🌍 Language Flags on Top */}
  <div className="flex gap-4 mb-4">
    <img
      src={flagIT}
      alt="IT"
      onClick={() => setLanguage("it")}
      className={`w-8 h-8 cursor-pointer hover:scale-110 transition ${
        language === "it" ? "opacity-100" : "opacity-40"
      }`}
    />
    <img
      src={flagEN}
      alt="EN"
      onClick={() => setLanguage("en")}
      className={`w-8 h-8 cursor-pointer hover:scale-110 transition ${
        language === "en" ? "opacity-100" : "opacity-40"
      }`}
    />
    <img
      src={flagFR}
      alt="FR"
      onClick={() => setLanguage("fr")}
      className={`w-8 h-8 cursor-pointer hover:scale-110 transition ${
        language === "fr" ? "opacity-100" : "opacity-40"
      }`}
    />
    <img
      src={flagDE}
      alt="DE"
      onClick={() => setLanguage("de")}
      className={`w-8 h-8 cursor-pointer hover:scale-110 transition ${
        language === "de" ? "opacity-100" : "opacity-40"
      }`}
    />
  </div>

  {/* 📄 Title */}
  <div className="flex items-center gap-3">
    <img src={regolamentoIcon} alt="Icona Regolamento" className="w-14 h-14" />
    <h1 className="text-4xl sm:text-5xl text-[#009FB7]">{activeRules.title}</h1>
  </div>
</div>


        {/* Rule List */}
        <div className="max-w-3xl mx-auto space-y-6 text-left">
          {activeRules.entries.map((rule, idx) => (
            <div key={idx} className="flex items-center gap-4">
              <img src={rule.icon} alt="Icona" className="w-9 h-9" />
              <p className="leading-snug">{rule.text}</p>
            </div>
          ))}

          {/* Prohibited Section */}
          <div className="flex items-center justify-center mt-10">
            <FaBan className="text-4xl text-red-500" />
          </div>
          <h2 className="text-center text-xl font-bold">{activeRules.prohibited}</h2>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mt-4 text-center">
            <div className="flex flex-col items-center">
              <img src={animaliIcon} alt="Icona Animali" className="w-9 h-9" />
              <p>{activeRules.animals}</p>
            </div>
{/*             <div className="flex flex-col items-center">
              <img src={frigoIcon} alt="Icona Frigo" className="w-9 h-9" />
              <p>{activeRules.coolers}</p>
            </div> */}
          </div>

          {/* Footer Note */}
          <p className="text-sm text-center mt-10 whitespace-pre-line">{activeRules.extra}</p>
        </div>
      </div>

      <Footer />
    </div>
    </div>
  );
};

export default Regolamento;
